import {api} from '../../../shared/api';
import {
  CreateFundRepresentativeDTO,
  EditFundRepresentativeDTO,
  EditFundRepresentativeParams,
  FundRepresentativeModel,
  FundRepresentativesFilter,
  FundRepresentativeWithMetaModel,
} from '../model';

const BASE = '/api/iam/admin/fund-representatives';

export const fundRepresentativesApi = {
  getFundRepresentatives: async (
    params: FundRepresentativesFilter = {},
  ): Promise<FundRepresentativeWithMetaModel> => {
    // Бэкенд листает по курсору: размер страницы передаётся в first, а без него отдаётся 10 записей
    const {pageSize, after, ...restParams} = params;
    const queryParams = {
      ...restParams,
      ...(pageSize && {first: pageSize}),
      ...(after && {after}),
    };

    const {data} = await api.get<FundRepresentativeWithMetaModel>(BASE, {params: queryParams});
    return data;
  },

  create: async (dto: CreateFundRepresentativeDTO): Promise<FundRepresentativeModel> => {
    const {data} = await api.post<FundRepresentativeModel>(BASE, dto);
    return data;
  },

  getById: async (id: string): Promise<FundRepresentativeModel> => {
    const {data} = await api.get<FundRepresentativeModel>(`${BASE}/${id}`);
    return data;
  },

  update: async ({representativeId, displayName}: EditFundRepresentativeParams): Promise<FundRepresentativeModel> => {
    const body: EditFundRepresentativeDTO = {displayName};
    const {data} = await api.put<FundRepresentativeModel>(`${BASE}/${representativeId}`, body);
    return data;
  },
};
